import { DateTime } from "luxon";
import type { WizardParkingChoice } from "../../../../PermitContextProvider/types";

export const useStartOptionsEnabled = (wizardSettings: WizardParkingChoice["time"], timezone: string): boolean => {
	const now = DateTime.utc().setZone(timezone);
	const todayStr = now.toFormat("yyyy-MM-dd");

	const isNowAllowedByStartTime = (() => {
		const minTime = wizardSettings.startTime.min;
		const maxTime = wizardSettings.startTime.max;

		if (minTime && maxTime) {
			const minDateTime = DateTime.fromFormat(`${todayStr} ${minTime}`, "yyyy-MM-dd HH:mm:ss");
			const maxDateTime = DateTime.fromFormat(`${todayStr} ${maxTime}`, "yyyy-MM-dd HH:mm:ss");
			return now >= minDateTime && now <= maxDateTime;
		}
		if (minTime) {
			const minDateTime = DateTime.fromFormat(`${todayStr} ${minTime}`, "yyyy-MM-dd HH:mm:ss");
			return now >= minDateTime;
		}
		if (maxTime) {
			const maxDateTime = DateTime.fromFormat(`${todayStr} ${maxTime}`, "yyyy-MM-dd HH:mm:ss");
			return now <= maxDateTime;
		}
		return true;
	})();

	const isNowAllowedByStartDate = (() => {
		const minDate = wizardSettings.startDate.min;
		const maxDate = wizardSettings.startDate.max;

		if (minDate && maxDate) {
			const minDateTime = DateTime.fromFormat(`${minDate} 00:00:00`, "yyyy-MM-dd HH:mm:ss");
			const maxDateTime = DateTime.fromFormat(`${maxDate} 23:59:59`, "yyyy-MM-dd HH:mm:ss");
			return now >= minDateTime && now <= maxDateTime;
		}
		if (minDate) {
			const minDateTime = DateTime.fromFormat(`${minDate} 00:00:00`, "yyyy-MM-dd HH:mm:ss");
			return now >= minDateTime;
		}
		if (maxDate) {
			const maxDateTime = DateTime.fromFormat(`${maxDate} 23:59:59`, "yyyy-MM-dd HH:mm:ss");
			return now <= maxDateTime;
		}
		return true;
	})();

	return (
		wizardSettings.startDate.enabled &&
		wizardSettings.startTime.enabled &&
		isNowAllowedByStartTime &&
		isNowAllowedByStartDate
	);
};
